import { CustomTypeEnum } from '@semanticedge/persistence-service-noheaders-client/src'

type SchemaColumnInputType = 'boolean' | 'integer' | 'float' | 'string'

type SchemaColumnTypeConfig = {
	inputType: SchemaColumnInputType
	numberType?: 'INTEGER' | 'FLOAT'
}

const SCHEMA_COLUMN_TYPE_CONFIG: Partial<Record<CustomTypeEnum, SchemaColumnTypeConfig>> = {
	[CustomTypeEnum.Boolean]: { inputType: 'boolean' },
	[CustomTypeEnum.Integer]: { inputType: 'integer', numberType: 'INTEGER' },
	[CustomTypeEnum.Float]: { inputType: 'float', numberType: 'FLOAT' },
	[CustomTypeEnum.String]: { inputType: 'string' }
}

const DEFAULT_SCHEMA_COLUMN_TYPE_CONFIG: SchemaColumnTypeConfig = { inputType: 'string' }

export const getSchemaColumnTypeConfig = (
	columnType: CustomTypeEnum | undefined
): SchemaColumnTypeConfig =>
	(columnType && SCHEMA_COLUMN_TYPE_CONFIG[columnType]) ?? DEFAULT_SCHEMA_COLUMN_TYPE_CONFIG

export const isBooleanColumnType = (columnType: CustomTypeEnum | undefined): boolean =>
	getSchemaColumnTypeConfig(columnType).inputType === 'boolean'

type ManualValueSerializer = (raw: string | boolean | number) => string | number | boolean

const SERIALIZE_BY_INPUT_TYPE = {
	boolean: (raw) => raw === true || raw === 'true',
	integer: (raw) => Number.parseInt(String(raw), 10),
	float: (raw) => Number.parseFloat(String(raw)),
	string: (raw) => String(raw)
} as const satisfies Record<SchemaColumnInputType, ManualValueSerializer>

export const serializeManualColumnValue = (
	columnType: CustomTypeEnum | undefined,
	raw: string | boolean | number
): string | number | boolean =>
	SERIALIZE_BY_INPUT_TYPE[getSchemaColumnTypeConfig(columnType).inputType](raw)
